var DOMWindow = /*#__PURE__*/ function () {
    function DOMWindow() { }
    DOMWindow.location = function location() {
        if (this.isDefined())
            return window.location;
    };
    DOMWindow.locationPathname = function locationPathname() {
        return this.isDefined() ? window.location.pathname : "";
    };
    DOMWindow.innerWidth = function innerWidth() {
        return this.isDefined() ? window.innerWidth : -1;
    };
    DOMWindow.innerHeight = function innerHeight() {
        return this.isDefined() ? window.innerHeight : -1;
    };
    DOMWindow.scrollBy = function scrollBy(options) {
        return this.isDefined() ? window.scrollBy(options) : -1;
    };
    DOMWindow.addEventListener = function addEventListener(type, listener, options) {
        if (this.isDefined())
            window.addEventListener(type, listener, options);
    };
    DOMWindow.removeEventListener = function removeEventListener(type, listener, options) {
        if (this.isDefined())
            window.removeEventListener(type, listener, options);
    };
    DOMWindow.isDefined = function isDefined() {
        return typeof window !== "undefined" && !!window;
    };
    return DOMWindow;
}();
export { DOMWindow as default };
